import React from 'react';
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import './codeBlockComponent.scss';

import { v4 as uuidv4 } from 'uuid';
/* eslint react/prop-types: 0 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
/* @ts-ignore */
export default function CodeBlockComponent({
  node: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    attrs: { language: defaultLanguage },
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  updateAttributes,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  extension,
}) {
  return (
    <NodeViewWrapper className="code-block">
      <select
        contentEditable={false}
        defaultValue={defaultLanguage}
        onChange={(event) => updateAttributes({ language: event.target.value })}
      >
        <option value="null">auto</option>
        <option disabled>—</option>
        {extension.options.lowlight.listLanguages().map((lang: string) => (
          <option key={uuidv4()} value={lang}>
            {lang}
          </option>
        ))}
      </select>
      <pre>
        <NodeViewContent as="code" />
      </pre>
    </NodeViewWrapper>
  );
}
